// extracted by mini-css-extract-plugin
export default {"card":"V1-z"};